import { render, staticRenderFns } from "./ChangePassword.html?vue&type=template&id=746bc1e6&scoped=true&external"
import script from "./ChangePassword.js?vue&type=script&lang=js&external"
export * from "./ChangePassword.js?vue&type=script&lang=js&external"
import style0 from "./ChangePassword.scss?vue&type=style&index=0&id=746bc1e6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746bc1e6",
  null
  
)

export default component.exports